var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconErrorNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6C33.9411 6 42 14.0589 42 24C42 33.9411 33.9411 42 24 42C14.0589 42 6 33.9411 6 24C6 14.0589 14.0589 6 24 6ZM30.0459 17.9541C29.5188 17.427 28.6639 17.4272 28.1367 17.9541L24 22.0908L19.8633 17.9541C19.3361 17.4269 18.4813 17.4269 17.9541 17.9541C17.4269 18.4813 17.4269 19.3361 17.9541 19.8633L22.0908 24L17.9541 28.1367C17.4269 28.6639 17.4269 29.5187 17.9541 30.0459C18.4813 30.573 19.3361 30.573 19.8633 30.0459L24 25.9092L28.1367 30.0459C28.664 30.5727 29.5188 30.573 30.0459 30.0459C30.573 29.5188 30.5727 28.664 30.0459 28.1367L25.9092 24L30.0459 19.8633C30.5728 19.3361 30.5729 18.4812 30.0459 17.9541Z",
    fill: "#C30000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorNoti);
export default __webpack_public_path__ + "static/media/iconErrorNoti.bccb1e61fdaab5f75c3f487ac177efc1.svg";
export { ForwardRef as ReactComponent };